import { Injectable, inject } from '@angular/core';

import { map, Observable } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';

import { TellentImpactTrackerData } from '../types';

@Injectable({ providedIn: 'root' })
export class TellentImpactTrackerHttpClient {
  protected readonly httpApi = inject(TellentHttpApiService);

  public fetchCollection(): Observable<TellentImpactTrackerData[]> {
    return this.httpApi
      .get('/impact_tracker/summary')
      .pipe(map((response: { data: TellentImpactTrackerData[] }) => response.data));
  }
}
